// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UZUOx","title":"styles_title__wkD1e"};